import { pedidoCategory } from './pedidoListingRows';

export default function pedidoSituacaoAtual(item = {}) {
  const category = pedidoCategory(item);
  if (category === 'BACK ORDER' || item.pedidoCategoria) return category;
  const sales = item.pedidoSitSales || item.pedidositsales || '';
  if (['EM APROVAÇÃO', 'APROVANDO', 'CANCELADO', 'RECUSADO', 'REJEITADO', 'REPROVADO', 'RASCUNHO']
    .includes(String(sales).trim().toUpperCase())) return sales;
  const current = !item._isBackorder && item.atendimento && item.atendimento.situacaoAtual;
  return (current && (current.situacaoMac || current.situacaoErp))
    || item.pedidoSitComercial || item.pedidositcomercial || sales || '-';
}